import classnames from 'classnames';
import { useContext } from 'react';
import { FiltersPanel } from '@common/Filters/containers';
import ListingContext from '@common/Listing/ListingContext';
import { SubCategories } from '@common/SubCategories/containers/SubCategories';
import './ListingTopMobile.scss';

export default function ListingTopMobile({
    filtersProps,
    onModalClose
}) {
    const { categoryMenu } = filtersProps;
    const { isPremium } = useContext(ListingContext);
    const hasToShowSubcategories = categoryMenu && categoryMenu.children.length > 0;

    return (
        <>
            <FiltersPanel
                hasSubCategories={hasToShowSubcategories}
                onModalClose={onModalClose}
            />
            {hasToShowSubcategories
                && (
                    <SubCategories
                        customClass={classnames('listing-top-mobile__subcategories', {
                            'listing-top-mobile__subcategories--premium': isPremium
                        })}
                        subcategories={categoryMenu}
                    />
                )}
        </>
    );
}
